import CoExtensionPlanLayout from '@/views/CoHome';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';
import {lazyReactInVue} from 'vuereact-combined';

export default [
    {
        path: '/co-extension-plan',
        component: CoExtensionPlanLayout,
        meta: {
            title: '共拓计划'
        },
        children: [
            {
                path: '',
                name: 'coExtensionHome',
                meta: {
                    title: '欢迎',
                    allowNotLogin: true
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('CoExtension', () =>
                    import('../model/CoExtension')
                ),
                component: lazyReactInVue(() => import('../react_app/CoExtensionHome'))
            },
            {
                path: 'market',
                name: 'coExtensionMarket',
                meta: {
                    title: '共拓计划-工具集',
                    showBg: true,
                    allowNotLogin: true
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('CoExtension', () =>
                    import('../model/CoExtension')
                ),
                component: lazyReactInVue(() => import('../react_app/CoExtensionMarket'))
            },
            {
                path: 'market/:type',
                name: 'coExtensionMarketDetail',
                meta: {
                    allowNotLogin: true
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('CoExtension', () =>
                    import('../model/CoExtension')
                ),
                component: lazyReactInVue(() => import('../react_app/CoExtensionMarketDetail'))
            }
        ]
    }
];